var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInword0101({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.83,13.21a.41.41,0,0,1-.32.46c-1.69.62-3.37,1.26-5,1.9l-.25.08V11.43l.3-.11,5.31-2C14.83,10.63,14.81,11.92,14.83,13.21Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.05,6.55,17.32,7.8l-8.11,3c0-.71,0-1.41,0-2.12a.33.33,0,0,1,.26-.36Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.86,6.69,9.32,4.18l.06,0,2.06-.7a.58.58,0,0,1,.32,0l6,2.25.11.07Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.92,11.3l.66.26v4a.58.58,0,0,1,0,.1.39.39,0,0,1-.15,0L3.55,13.93a.42.42,0,0,1-.32-.28,1.12,1.12,0,0,1,0-.2c0-.13,0-.27,0-.41,0-1.2,0-2.41,0-3.61Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.75,6.62,0,5.85l.77-.31c1.69-.68,3.38-1.37,5.08-2a.72.72,0,0,1,.48,0c.7.22,1.39.45,2.12.7Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.58,8.64v2.3L.37,7.67,3.85,6.41l4.5,1.92C8.5,8.39,8.58,8.45,8.58,8.64Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.4,6.27c0-.36,0-.66,0-.95,0-.76,0-1.52,0-2.28,0-.46.23-.71.58-.69s.54.27.53.73c0,.87,0,1.74-.05,2.6,0,.11,0,.23,0,.41l.74-.58c.11-.08.21-.17.32-.24a.56.56,0,0,1,.75.1.54.54,0,0,1-.05.75c-.67.55-1.36,1.1-2.07,1.61a.63.63,0,0,1-.58,0C7.9,7.3,7.2,6.84,6.5,6.37a.56.56,0,1,1,.61-.93C7.52,5.69,7.92,6,8.4,6.27Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInword0101);
export default __webpack_public_path__ + "static/media/inword-01-01.fde3c245.svg";
export { ForwardRef as ReactComponent };